// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "picture[data-v-6d09269d]{display:contents}img[data-v-6d09269d]{display:block;max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
